var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmQuotes = function SvgBmQuotes(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ab,.bb{fill:#fff;}.ab{opacity:0.001;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-352 -33)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    width: 18,
    height: 18,
    transform: "translate(352 33)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(351 33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M17,0H2.6A.6.6,0,0,0,2,.6V17.4a.6.6,0,0,0,.6.6H17a.6.6,0,0,0,.6-.6V.6A.6.6,0,0,0,17,0Zm-.6,1.2v6H3.2v-6ZM3.2,16.8V8.4H16.4v8.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bb",
    width: 2.4,
    height: 6,
    rx: 1,
    transform: "translate(12.2 9.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bb",
    width: 2.4,
    height: 2.4,
    rx: 1,
    transform: "translate(8.6 13.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bb",
    width: 2.4,
    height: 2.4,
    rx: 1,
    transform: "translate(5 13.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bb",
    width: 2.4,
    height: 2.4,
    rx: 1,
    transform: "translate(8.6 9.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bb",
    width: 2.4,
    height: 2.4,
    rx: 1,
    transform: "translate(5 9.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M19.668,6.114l.919.277a.2.2,0,0,1,.124.088.3.3,0,0,1,.051.175.238.238,0,0,1-.073.175.223.223,0,0,1-.16.073h-.569a.487.487,0,0,1-.263-.073.149.149,0,0,0-.2.015l-.233.233A.146.146,0,0,0,19.2,7.2a.138.138,0,0,0,.073.124,1.111,1.111,0,0,0,.627.218v.248a.253.253,0,0,0,.066.175.216.216,0,0,0,.167.073h.161a.25.25,0,0,0,.248-.248V7.557a.861.861,0,0,0,.613-.277.949.949,0,0,0,.073-1.189.867.867,0,0,0-.467-.328l-.9-.277a.2.2,0,0,1-.124-.088.3.3,0,0,1-.051-.175.263.263,0,0,1,.073-.182.173.173,0,0,1,.161-.066h.569a.383.383,0,0,1,.262.066.145.145,0,0,0,.2-.007l.233-.233a.13.13,0,0,0,.051-.124.164.164,0,0,0-.065-.124,1.11,1.11,0,0,0-.627-.219V4.087a.239.239,0,0,0-.073-.175.222.222,0,0,0-.16-.073h-.175a.222.222,0,0,0-.16.073.239.239,0,0,0-.073.175V4.32a.858.858,0,0,0-.612.277.948.948,0,0,0-.073,1.189A.868.868,0,0,0,19.668,6.114Z",
    transform: "translate(-6.816 -1.536)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Quotes.d9981586.svg";
export { ForwardRef as ReactComponent };